import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, Paper } from '@mui/material';
import { httpRequest } from 'src/services/httpRequest';

interface Dashboard {
    TotalTownships: number;
    ActivePermits: number;
    TotalAdmins: number;
    ActiveSubscription: number;
}

const SuperAdmin: React.FC = () => {

    const [dashboardData, setDashboardData] = useState<Dashboard>({
        TotalTownships: 0,
        ActivePermits: 0,
        TotalAdmins: 0,
        ActiveSubscription: 0
    })

    // Get Dashboard Data
    useEffect(() => {
        const getDashboardData = async () => {
            const response = await httpRequest('GET', '/townships/dashboard')
            if (response?.status === 'success') {
                setDashboardData(response?.data)
            }
        }
        getDashboardData()
    }, [])

    // Dashboard Items
    const dashboardItems = [
        { label: 'Total Townships', value: dashboardData?.TotalTownships },
        { label: 'Active Subscriptions', value: dashboardData?.ActiveSubscription },
        { label: 'Active Permits', value: dashboardData?.ActivePermits },
        { label: 'Total Admins', value: dashboardData?.TotalAdmins },
    ];

    return (
        <Box sx={{ p: 4, backgroundColor: '#f9f9f9', minHeight: '100vh' }}>
            <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold' }}>
                Dashboard Overview
            </Typography>
            <Grid container spacing={3}>
                {/* Metric Cards */}
                {dashboardItems.map((item, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                        <Paper elevation={3} sx={{ p: 2, textAlign: 'center' }}>
                            <Typography variant="h6" sx={{ color: '#666' }}>
                                {item.label}
                            </Typography>
                            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                                {item.value}
                            </Typography>
                        </Paper>
                    </Grid>
                ))}
            </Grid>

            {/* Lower Section */}
            <Grid container spacing={3} sx={{ mt: 4 }}>
                {/* Subscription Revenue */}
                <Grid item xs={12} md={6}>
                    <Paper elevation={3} sx={{ p: 3, height: '100%' }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Subscription Revenue
                        </Typography>
                        <Box
                            sx={{
                                height: '200px',
                                backgroundColor: '#e0e0e0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography variant="body1" sx={{ color: '#999' }}>
                                Chart Placeholder
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>

                {/* Required Actions */}
                <Grid item xs={12} md={6}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Required Actions
                        </Typography>
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="body1">
                                Subscription Renewal - <strong>Springfield Township</strong>
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#666' }}>
                                2 days
                            </Typography>
                        </Box>
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="body1">
                                Admin Approval - <strong>Riverdale County</strong>
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#666' }}>
                                1 day
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant="body1">
                                Update Required - <strong>East Hampton</strong>
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#f44336' }}>
                                Today
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};

export default SuperAdmin;
